// John Eldhose 20190429
import React, { Component } from 'react';
import { Button, Grid, IconButton, MenuItem, TextField, Typography } from '@material-ui/core';
import { FileDownload, Search, Send, WebAsset } from '@material-ui/icons';
import { FormattedMessage } from 'react-intl';
import ReactTable from "react-table";
import ProfileAddress from '../lib/ProfileAddress';
import Loading from '../lib/Loading';
import { postData } from '../lib/api';

class Downloads extends Component {

  state = {
    step: 'begin',
    profile: null,
    address: null,
    serial: '',
    prompt: {},
    support: ''
  }
  downloadRef = React.createRef();
  sns = {};
  handleSearch = () => {
    if(this.state.serial === '')
      this.setState({ step: 'error' });
    else if(typeof this.sns[this.state.serial] === 'undefined') {
      this.setState({ step: 'loading' });
      const s = this.state;
      postData('getDownloads', {
        sn: s.serial, profile: s.profile, address: s.address
      })
        .then((res) => {
          if(res.status === 'true') {
            this.sns[s.serial] = res.data;
            this.setState({ step: 'found' });
          }
          else {
            this.sns[s.serial] = null;
            this.setState({ step: 'ineligible' });
          }
        })
        .catch(() => { this.setState({ step: 'error' }); })
    }
    else if(this.sns[this.state.serial] === null)
      this.setState({ step: 'ineligible' });
    else
      this.setState({ step: 'found' });
  }
  handleDownload = (row) => {

    if(this.state.serial === '')
      this.setState({ step: 'error' });
    else {
      this.setState({ step: 'found_loading' });
      const s = this.state;
      postData('getDownloads', {
        sn: s.serial, profile: s.profile, address: s.address,
        download: [row.url, row.name]
      })
        .then((res) => {
          if(res.status === 'true') {
            this.setState({ step: 'found' });
            this.downloadRef.current.src = res.data.url;
          }
          else
            this.setState({ step: 'found_error' });
        })
        .catch(() => { this.setState({ step: 'found_error' }); })
    }
  }
  handleSupport = () => {
    if(this.state.serial === '' || this.state.support === '')
      this.setState({ step: 'error' });
    else {
      this.setState({ step: 'found_loading' });
      const s = this.state;
      postData('getDownloads', {
        sn: s.serial, profile: s.profile, address: s.address, support: s.support
      })
        .then((res) => {
          this.setState(
            { step: ((res.status === 'true') ? 'found_sent' : 'found_error') }
          );
        })
        .catch(() => { this.setState({ step: 'found_error' }); })
    }
  }
  columns = [
    {
      Header: (<Typography variant='subheading'>Name</Typography>),
      accessor: 'name',
      Cell: row => (
        <Typography>
          {row.value}
          <IconButton
            color='primary'
            onClick={() => this.handleDownload(row.original)}
          >
            <FileDownload />
          </IconButton>
        </Typography>
      )
    },
    {
      Header: (<Typography variant='subheading'>Size</Typography>),
      accessor: 'size', width: 90,
      Cell: row => (<Typography>{row.value}</Typography>)
    },
    {
      Header: (<Typography variant='subheading'>Date</Typography>),
      accessor: 'date', width: 90,
      Cell: row => (<Typography>{row.value}</Typography>)
    },
    {
      Header: (<Typography variant='subheading'>Description</Typography>),
      accessor: 'desc',
      Cell: row => (<Typography dangerouslySetInnerHTML={{__html: row.value}} />),
      style: { 'whiteSpace': 'unset', 'textAlign': ' justify' }
    }
  ];
  downloads = (data, url) => {
    var conf = {};
    if(typeof data['config.ini'] !== 'undefined') {
      conf = data['config.ini'];
      delete(data['config.ini']);
    }
    if(typeof conf.prompt === 'undefined')
      conf.prompt = '';
    var _downloads_ = null;
    if(typeof data['_downloads_'] !== 'undefined') {
      switch(this.state.step) {
        case 'found_loading':
          return <Loading minHeight={100} />;
        default:
          data['_downloads_'].map((row) => row.url = url);
          _downloads_ = (
            <div style={{ padding: '20px 0' }}>
              <ReactTable
                columns={this.columns}
                data={data['_downloads_']}
                showPagination={false}
                pageSize={data['_downloads_'].length}
              />
            </div>
          );
          delete data['_downloads_'];
      }
    }
    const dirs = Object.keys(data);
    var names = [];
    dirs.map((dir, i) => (
      names[i] = (
        typeof data[dir] === 'object' &&
        typeof data[dir]['config.ini'] === 'object' &&
        typeof data[dir]['config.ini']['name'] !== 'undefined'
      ) ? data[dir]['config.ini']['name'] : dir
    ));
    if(dirs.length < 1) {
      if(typeof conf.prompt === 'string' && conf.prompt === '_support_') {
        switch(this.state.step) {
          case 'found_error':
            return <Typography>Unknown error occurred</Typography>;
          case 'found_loading':
            return <Loading minHeight={100} />;
          case 'found_sent':
            return (
              <Typography style={{ padding: '20px 0' }}>
                Your request is sent. One of our support agent will contact you shortly.
              </Typography>
            );
          default:
            return (
              <div style={{ padding: '20px 0' }}>
                <Typography>
                  Please specify which product and version you are requesting and one of our support agent will contact you
                </Typography>
                <TextField
                  required
                  fullWidth
                  multiline={true}
                  rows={3}
                  value={this.state.support}
                  onChange={(e) => this.setState({ support: e.target.value })}
                  style={{ border: 'solid silver 1px', margin: '10px 0' }}
                />
                <Button
                  variant='raised'
                  color='primary'
                  onClick={this.handleSupport}
                  disabled={(this.state.support === '')}
                >
                  <Send /> &nbsp;Send
                </Button>
              </div>
            );
        }
      }
      else
        return <div>{_downloads_}</div>;
    }
    else if(dirs.length === 1) {
      return (
        <div>
          <Grid container justify='space-between' spacing={40}>
            <Grid item size={6}>
              <Typography variant='subheading'>{conf.prompt}</Typography>
            </Grid>
            <Grid item size={6}>
              <Typography variant='subheading'>{names[0]}</Typography>
            </Grid>
          </Grid>
          {this.downloads(data[dirs[0]], url + '/' + dirs[0])}
          {_downloads_}
        </div>
      );
    }
    else {
      var prompt = this.state.prompt;
      if(typeof prompt[conf.prompt] === 'undefined')
        prompt[conf.prompt] = (typeof conf.default === 'undefined') ?
          '' : conf.default;
      return (
        <div>
          <Grid container justify='space-between' spacing={40}>
            <Grid item size={6}>
              <Typography variant='subheading'>{conf.prompt}</Typography>
            </Grid>
            <Grid item size={6}>
              <TextField
                select
                value={prompt[conf.prompt]}
                onChange={(e) => {
                  prompt[conf.prompt] = e.target.value;
                  this.setState({ prompt: prompt });
                }}
              > {dirs.map((dir, i) => (
                  <MenuItem key={i} value={dir}>{names[i]}</MenuItem>
                ))}
              </TextField>
            </Grid>
          </Grid>
          {this.downloads(data[prompt[conf.prompt]], url + '/' + prompt[conf.prompt])}
          {_downloads_}
        </div>
      );
    }
  }
  content = () => {
    switch(this.state.step) {
      case 'blank':
        return (
          <Typography style={{ color: '#f00' }}>
            Serial number is required<br />Please enter a valid serial number
          </Typography>
        );
      case 'error':
        return <Typography>Unknown error occurred</Typography>;
      case 'found':
      case 'found_error':
      case 'found_loading':
      case 'found_sent':
        if(typeof this.sns[this.state.serial] === 'object') {
          return (
            <Grid container justify='center'>
              <Grid item xs={12} sm={12} md={2} lg={2} xl={2} />
              <Grid item xs={12} sm={12} md={8} lg={8} xl={8}>
                {this.downloads(JSON.parse(JSON.stringify(this.sns[this.state.serial])), '')}
                <iframe
                  ref={this.downloadRef}
                  style={{ display: 'none' }}
                  title='Download'
                  src=''
                />
              </Grid>
              <Grid item xs={12} sm={12} md={2} lg={2} xl={2} />
            </Grid>
          );
        }
        else
          this.setState({ step: 'error' });
        break;
      case 'ineligible':
        return (
          <Typography style={{ color: '#f00' }}>
            Invalid Serial Number<br />or<br />
            Serial number is not eligible for download
          </Typography>
        );
      case 'loading':
        return <Loading minHeight={100} />;
      default:
        if(this.state.serial === '')
          return <Typography>Please enter a valid serial number</Typography>;
        else
          return <div />;
    }
  }

  render() {
    if(this.state.profile === null || this.state.address === null)
      return (
        <ProfileAddress
          NoBillTo={true}
          NoBackButton={true}
          Continue={(p, a, b) => this.setState({ profile: p, address: a })}
        />
      );
    else
      return (
        <div>
          <Typography variant='display1'>
            <center>
              <font color='#385687'>
                <FormattedMessage
                  id='Product Downloads'
                  defaultMessage='Product Downloads'
                />
              </font>
            </center>
          </Typography>
          <p />
          <Grid container>
            <Grid item xs={12} sm={12} md={2} lg={2} xl={2} />
            <Grid item xs={12} sm={12} md={8} lg={8} xl={8}>
              <TextField
                style={{ border: '1px solid silver', borderRadius: '5px', boxShadow: '1px 1px 1px 1px #888888' }}
                fullWidth
                autoFocus={true}
                placeholder={
                  <FormattedMessage
                    id='Serial Number'
                    defaultMessage='Serial Number'
                  />
                }
                value={this.state.serial}
                onKeyPress={this.handleEnter}
                onChange={(e) => this.setState({
                  serial: e.target.value.toUpperCase(),
                  step: 'begin', download: null, support: ''
                })}
                InputProps={{
                  disableUnderline: true,
                  startAdornment: (
                    <div style={{ backgroundColor: '#ecf0f1', padding: '10px 10px 0px 10px', borderRadius: '5px 0px 0px 5px', margin: '0px 10px 0px 0px' }}>
                      <WebAsset />
                    </div>
                  ),
                  endAdornment: (
                    <div style={{ backgroundColor: '#ecf0f1', borderRadius: '0px 5px 5px 0px' }}>
                      <IconButton onClick={this.handleSearch}>
                        <Search color='primary' />
                      </IconButton>
                    </div>
                  )
                }}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={2} lg={2} xl={2} />
          </Grid>
          <br />
          <div style={{ minHeight: '100px' }}>
            {this.content()}
          </div>
        </div>
      );
  }
}

export default Downloads;



// WEBPACK FOOTER //
// ./src/components/home/Downloads.js